import { useCallback, useEffect, useRef, useState } from 'react'
import Router from 'next/router'
import useNotifications from '../../hooks/use-notifications'
import useClickOutside from '../../hooks/use-clickoutside'
import { useAuth } from '../../contexts/auth'
import AvatarSvg from '../svg/avatar'
import { Desktop, Mobile } from '../media'
import Menu from './menu'
import Avatar from '../avatar'
import DealerAvatar from '../svg/avatar-dealer'
import Message from '../svg/message'
import { ROUTES } from '../../constants'
import { NotificationType } from '../../api-client/enums'
import { useRouter } from 'next/router'

export default function UserMenu() {
  const { isNotifications, notifications, refetchNotifications } = useNotifications()
  const dropdownRef = useRef()
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
  const [{ userDetails }, { logout }] = useAuth()
  const [chatCount, setChatCount] = useState(0)

  const router = useRouter()
  const closeDropdown = useCallback(() => {
    setDropdownIsOpen(false)
  }, [])

  const toggleDropdown = useCallback(() => {
    setDropdownIsOpen((prev) => !prev)
  }, [])

  useClickOutside(dropdownRef, closeDropdown, !dropdownIsOpen)

  useEffect(() => {
    Router.events.on('routeChangeComplete', closeDropdown)

    return () => Router.events.off('routeChangeComplete', closeDropdown)
  }, [closeDropdown])

  const handleMessageClick = useCallback(() => {
    Router.push(`${ROUTES.Account}#chatHistory`)
  }, [])

  useEffect(() => {
    setChatCount(
      new Set(notifications[NotificationType.Message]?.map((chat) => chat.conversationId)).size,
    )
  }, [notifications])

  useEffect(() => {
    refetchNotifications()
  }, [router.asPath]) //eslint-disable-line
  // not including refetchNotifications here since it would trigger an infinite loop
  return (
    <div className='wrapper'>
      <Desktop>
        <button className='flatBtn profile' onClick={toggleDropdown}>
          <Avatar
            alt='user avatar'
            src={userDetails.profileImageUrl}
            width={50}
            height={50}
            fallbackComponent={userDetails.isDealer ? DealerAvatar : AvatarSvg}
          />
        </button>
        {isNotifications &&
          (notifications[NotificationType.Bidding] ||
            notifications[NotificationType.Vehicle] ||
            notifications[NotificationType.Favorite]) && (
            <div className='notifications' aria-label='active notification' />
          )}{' '}
        {notifications[NotificationType.Message]?.length > 0 && (
          <div className='chat' onClick={handleMessageClick}>
            <Message fill='var(--alert-color)' count={chatCount} />
          </div>
        )}
        {dropdownIsOpen && (
          <div className='menuWrapper' ref={dropdownRef}>
            <Menu onLogout={logout} />
          </div>
        )}
      </Desktop>
      <Mobile>
        <Menu onLogout={logout} />
      </Mobile>

      <style jsx>{`
        .wrapper {
          position: relative;

          .menuWrapper {
            position: absolute;
            right: 0;
          }
        }

        .notifications {
          position: absolute;
          right: 0rem;
          bottom: 0rem;
          width: 2rem;
          height: 2rem;
          background: var(--alert-color);
          border-radius: 50%;
          color: #fff;
        }
        .chat {
          position: absolute;
          left: 4rem;
          top: -1rem;
          cursor: pointer;
        }

        .profile {
          position: relative;
          width: 5rem;
          height: 5rem;
        }

        @media (max-width: 1024px) {
          .menuWrapper {
            left: 0;
            min-width: 200px;
          }
        }
      `}</style>
    </div>
  )
}
